import { Box, Typography } from '@mui/material';
import { startCase } from 'lodash';
import ModalComponent from 'src/components/Modal/ModalComponent';
import { TypeCompareSocialMedia } from 'src/features/CompareCompany/Common/config';
import ContactTable from 'src/features/CompareCompany/ContactTable';
import NegativeMediaTable from 'src/features/CompareCompany/NegativeMediaTable';
import SocialMediaTable from 'src/features/CompareCompany/SocialMediaTable';
import StockTable from 'src/features/CompareCompany/StockTable';

const PopupMedia = ({
  open,
  handleClose,
  selectedMediaType,
  selectedRecord,
}: {
  open: boolean;
  handleClose: () => void;
  selectedMediaType: TypeCompareSocialMedia;
  selectedRecord?: ICompareCompany;
}) => {
  const renderTable = () => {
    switch (selectedMediaType) {
      case 'negative_media':
        return <NegativeMediaTable id={selectedRecord?.id} />;
      case 'contact':
        return <ContactTable id={selectedRecord?.id} />;
      case 'social_media':
        return <SocialMediaTable id={selectedRecord?.id} />;
      case 'stock_listing':
        return <StockTable id={selectedRecord?.id} />;
      default:
        return <NegativeMediaTable id={selectedRecord?.id} />;
    }
  };

  const renderTitle = () => {
    switch (selectedMediaType) {
      case 'stock_listing':
      case 'negative_media':
        return (
          <Typography mb={3} variant="h5">
            {startCase(selectedMediaType)}
          </Typography>
        );
      default:
        return null;
    }
  };

  return (
    <ModalComponent styleBox={{ width: 1000 }} open={open} handleClose={handleClose}>
      <Box>
        {renderTitle()}
        {renderTable()}
      </Box>
    </ModalComponent>
  );
};

export default PopupMedia;
